import Vue from 'vue'
import Vuex from 'vuex'
import { mobileMentorQuestions_arr, pretestQuestions_arr, media_arr, glossary_arr } from '../data.js'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mobileMentorQuestions: mobileMentorQuestions_arr,
    pretestQuestions: pretestQuestions_arr,
    mediaItems: media_arr,
    glossaryTerms: glossary_arr,
    small: true,
    canSkip: true, // Allow the user to skip the pretest by pressing the "s" key or clicking the logo in the top banner during the pretest.
    randomize: false, // Allow the pretest questions to be randomized when starting the pretest.
    showFeedback: false, // Provide additional feedback on the pretest review screen when toggling the dropdowns on the right side.
    showIntro: true,
    showPretest: false,
    showResults: false,
    showReport: false,
    showTOC: false,
    showSearch: false,
    showMobileMentor: false,
    showModal: false,
    showBlocker: false,
    currentPretestQuestion: 0,
    currentPretestPage: 1,
    preTestIndex: '',
    trackingData_str: '',
    pretestAnswers: [],
    currentModule: '',
    currentModuleQuestion: '',
    previousModuleQuestion: '',
    correct: 0,
    incorrect: 0,
    percentCorrect: 0,
    minimumScore: null, // Minimum score needed to "pass" the pretest.
    maximumAttempts: null, // Maximum number of attempts allowed on the pretest before attestation button can be clicked without passing, if relevant.
    completed: false,
    completedPretest: false,
    moduleAssetFolderName: 'alpha', // The name of the folder under public/assets/modules/ where you're storing the image assets for the module.
    moduleTitle: 'Launch Grader', // The name of the module.  Will show up as the tab title.
    disclaimer: 'Powered by CLD',
    trackingType: 'cd', // The type of tracking string to set up for either local ('cd') or LMS ('scorm') storage for revisits to the app.
    trackingId: 'LaunchGrader', // The ID the module will go by when checking for storage for the trackingType. Probably just set it to the module name or similar.
    trackingString: '', // completedEntireModule|completedPretest|viewedMobileMentorQuestionIDs  (ex: 0|1|0_0_1,2_1_0,3_2_2)
    searchQuery: '', 
    searchMatches: [],
    requiresAttestation: false, // Whether or not you want an attestation button to be clicked when completing the module.
    hasMobileMentor: true, // Whether or not the app has a Mobile Mentor component.
    hasPretest: true, // Whether or not the app has a Pretest component.
    hasBibliography: false, // Whther or not the app needs a bibliography/references link in the Mobile Mentor Table of Contents
    hasGlossary: false, // Whther or not the app needs a glossary link in the Mobile Mentor Table of Contents
    viewedQuestions: [],
    questionHistory: [],
    sectionsToReview: [],
  },
  mutations: {
    hideIntro(state){
      state.showIntro = false;

      // Uncomment here and comment out other block for jumping straight to content from the intro component if necessary
        // NOTE: Make sure to also uncomment the relevant bits in the intro component to have the button change based on pretest availability/completion 
        // NOTE: Jumping straight to MM content from the intro in situations where a pretest exists won't have any sections marked for review
          // This is due to us not storing pretest answers between sessions
      // if(state.hasMobileMentor){
      //   if(state.hasPretest){
      //     if(state.completedPretest){
      //       state.showMobileMentor = true;
      //       state.currentModuleQuestion = state.mobileMentorQuestions[0].id;
      //     }else{
      //       state.showPretest = true;
      //     }
      //   }else{
      //     state.showMobileMentor = true;
      //     state.currentModuleQuestion = state.mobileMentorQuestions[0].id;
      //   }
      // }else{
      //   state.showPretest = true;
      // }

      if(state.hasPretest){
        state.showPretest = true;
      }else{
        state.showMobileMentor = true;
        state.currentModuleQuestion = state.mobileMentorQuestions[0].id;
      }
    },
    hideResults(state){
      state.showResults = false;
    },
    hideReport(state){
      state.showReport = false;
    },
    displayResults(state){
      state.showTOC = false;
      state.showPretest = false;
      state.showMobileMentor = false;
      state.showResults = true;
      state.showReport = false;
    },
    displayReport(state){
      state.showTOC = false;
      state.showPretest = false;
      state.showMobileMentor = false;
      state.showResults = false;
      state.showReport = true;
    },
    openTOC(state){
      state.showTOC = true;
      state.showSearch = false;
    },
    closeTOC(state){
      state.showTOC = false;
    },
    openSearch(state){
      state.showSearch = true;
      state.showTOC = false;
    },
    closeSearch(state){
      state.showSearch = false;
    },
    closeModal(state){
      state.showModal = false;
    },
    openModal(state){
      state.showModal = true;
    },
    nextPretestQuestion(state){
      state.currentPretestQuestion++;
    },
    prevPretestQuestion(state){
      state.currentPretestQuestion--;
    },
    nextPretestPage(state){
      state.currentPretestPage++;
    },
    prevPretestPage(state){
      state.currentPretestPage--;
    },
    submitAnswer(state, answer){
      state.pretestAnswers.push(answer);
    },
    incrementCorrect(state){
      state.correct++;
    },
    incrementIncorrect(state){
      state.incorrect++;
    },
    resetResults(state){
      state.correct = 0;
      state.incorrect = 0;
      state.percentCorrect = 0;
    },
    calculateResults(state){
      state.percentCorrect = Math.round(state.correct/state.pretestQuestions.length * 100);
    },
    resetPretestState(state){
      state.currentPretestQuestion = 0;
      state.previousModuleQuestion = '';
      state.correct = 0;
      state.incorrect = 0;
      state.percentCorrect = 0;
      state.pretestAnswers = [];
    },
    retakePretest(state){
      state.currentPretestQuestion = 0;
      state.previousModuleQuestion = '';

      state.pretestAnswers = [];

      state.showTOC = false;
      state.showMobileMentor = false;
      state.showResults = false;
      state.showReport = false;
      state.showBlocker = false;
      state.showModal = false;

      state.showPretest = true;

      state.correct = 0;
      state.incorrect = 0;
      state.percentCorrect = 0;

    },
    // See https://stackoverflow.com/a/46545530
    randomizePretest(state){
      state.pretestQuestions = state.pretestQuestions.map(question => ({
        question, sort: Math.random()
      })).sort((a, b) => a.sort - b.sort).map(({ question }) => question);
    },
    completeModule(state, completionStatus){
      state.completed = completionStatus;
    },
    completePretest(state, completionStatus){
      state.completedPretest = completionStatus;
    },
    updateTrackingString(state, updatedString){
      state.trackingString = updatedString;
    },
    changeModule(state, newMod){
      state.currentModule = newMod;
    },
    changeModuleQuestion(state, newModQuestion){
      // update new module name if necessary
      let newModName = state.mobileMentorQuestions.find(question => question.id === newModQuestion.id).module;
      if(newModName !== state.currentModule){
        state.currentModule = newModName;
      }

      // add to list of viewed questions if necessary
      if(!state.viewedQuestions.includes(newModQuestion.id)){
        state.viewedQuestions.push(newModQuestion.id)
      }

      // add old/current question to history of viewed items
      if(state.questionHistory.slice(-1).pop() !== state.currentModuleQuestion){
        state.questionHistory.push(state.currentModuleQuestion)
      }

      // kill TOC/search and show new question
      state.showTOC = false;
      state.showSearch = false;
      state.currentModuleQuestion = newModQuestion.id;
    },
    updateViewedModuleQuestions(state, viewedModuleQuestionIDs){
      viewedModuleQuestionIDs.forEach(moduleQuestionID => {
        if(!state.viewedQuestions.includes(moduleQuestionID)){
          state.viewedQuestions.push(moduleQuestionID)
        }
      });
    },
    displayMobileMentor(state){
      state.showResults = false;
      state.showReport = false;
      state.showBlocker = false;
      state.showModal = false;
      state.showPretest = false;

      if(!state.currentModuleQuestion){
        state.currentModule = state.mobileMentorQuestions[0].module;
        state.currentModuleQuestion = state.mobileMentorQuestions[0].id;
      }

      state.showMobileMentor = true;
      state.showTOC = true;
    },
    updateHistory(state, newHistory){
      state.questionHistory = newHistory;
    },
    updateSearchQuery(state, newQuery){
      state.searchQuery = newQuery;
    },
    updateSearchMatches(state, newMatches){
      state.searchMatches = newMatches;
    },
    addSectionToReview(state, newSection){
      state.sectionsToReview.push(newSection)
    }
  },
  actions: {
    hideIntro({commit}){
      commit('hideIntro')
    },
    hideResults({commit}){
      commit('hideResults')
    },
    hideReport({commit}){
      commit('hideReport')
    },
    displayResults({commit}){
      commit('displayResults')
    },
    displayReport({commit}){
      commit('displayReport')
    },
    openSearch({commit}){
      commit('openSearch')
    },
    closeSearch({commit}){
      commit('closeSearch')
    },
    closeTOC({commit}){
      commit('closeTOC')
    },
    openTOC({commit}){
      commit('openTOC')
    },
    closeModal({commit}){
      commit('closeModal')
    },
    openModal({commit}){
      commit('openModal')
    },
    nextPretestQuestion({commit}){
      commit('nextPretestQuestion')
    },
    prevPretestQuestion({commit}){
      commit('prevPretestQuestion')
    },
    nextPretestPage({commit}){
      commit('nextPretestPage')
    },
    prevPretestPage({commit}){
      commit('prevPretestPage')
    },
    submitAnswer({commit}, answer){
      commit('submitAnswer', answer)
    },
    incrementCorrect({commit}){
      commit('incrementCorrect')
    },
    incrementIncorrect({commit}){
      commit('incrementIncorrect')
    },
    resetResults({commit}){
      commit('resetResults')
    },
    calculateResults({commit}){
      commit('calculateResults')
    },
    retakePretest({commit, dispatch}){
      if(this.state.randomize){
        dispatch('randomizePretest')
      }
      commit('retakePretest')
    },
    resetPretestState({commit}){
      commit('resetPretestState')
    },
    randomizePretest({commit}){
      commit('randomizePretest')
    },
    completeModule({commit, dispatch}, completionStatus){
      commit('completeModule', completionStatus)

      let curTrackingString = this.state.trackingString;
      let splitTrackingString = curTrackingString.split('|');
      splitTrackingString[0] = (completionStatus ? '1' : '0') // completedEntireModule|completedPretest|viewedMobileMentorQuestionIDs

      dispatch('updateTrackingString', (splitTrackingString.join('|')));
    },
    completePretest({commit, dispatch}, completionStatus){
      commit('completePretest', completionStatus)

      let curTrackingString = this.state.trackingString;
      let splitTrackingString = curTrackingString.split('|');
      splitTrackingString[1] = (completionStatus ? '1' : '0') // completedEntireModule|completedPretest|viewedMobileMentorQuestionIDs
      
      dispatch('updateTrackingString', (splitTrackingString.join('|')));
    },
    updateTrackingString({commit}, updatedString){
      commit('updateTrackingString', updatedString)
    },
    changeModule({commit}, newMod){
      commit('changeModule', newMod)
    },
    changeModuleQuestion({commit, dispatch}, newModQuestion){
      commit('changeModuleQuestion', newModQuestion)

      let curTrackingString = this.state.trackingString;
      let splitTrackingString = curTrackingString.split('|');
      splitTrackingString[2] = this.state.viewedQuestions.join(',') // completedEntireModule|completedPretest|viewedMobileMentorQuestionIDs

      dispatch('updateTrackingString', (splitTrackingString.join('|')));
    },
    updateViewedModuleQuestions({commit}, viewedModuleQuestionIDs){
      commit('updateViewedModuleQuestions', viewedModuleQuestionIDs)
    },
    displayMobileMentor({commit}){
      commit('displayMobileMentor')
    },
    updateHistory({commit}, newHistory){
      commit('updateHistory', newHistory)
    },
    addSectionToReview({commit}, newSection){
      commit('addSectionToReview', newSection)
    },
    updateSearchQuery({commit, dispatch}, newQuery){
      commit('updateSearchQuery', newQuery)
      dispatch('updateSearchMatches', newQuery)
    },
    updateSearchMatches({commit}, newQuery){
      let matches = [];
      let mobileMentorQuestions = this.state.mobileMentorQuestions;
      if(newQuery){
        var searched_term = newQuery.toLowerCase().trim();
        //escapes special characters so search term in parentheses will show
        RegExp.clean = function(str){
          return (str + '').replace(/[.?+^$[\]\\(){}|-]/g, "\\$&");
        }
        var searchTermEscape = RegExp.clean(searched_term);
        var extractSentencePattern = "([A-Z s(),-])*(" + searchTermEscape +")[^\\.;\\?\\!]*";
        for(var i = 0; i < mobileMentorQuestions.length; i++){
          var id = mobileMentorQuestions[i].id;
          var question_text = mobileMentorQuestions[i].question_text;
          var removeTagsPattern = /(<([^>]+)>)/ig;
          var question_body_stripped;
          //remove all bullets and replace with sequence so we still can group them
          question_body_stripped = mobileMentorQuestions[i].question_body.replace(/<li.*?>/g, 'zqbc');
          question_body_stripped = question_body_stripped.replace(/<\/li>/g, 'zqbd');
          //remove all td and replace with sequence so we still can group them
          question_body_stripped = question_body_stripped.replace(/<td.*?>/g, 'zqbc');
          question_body_stripped = question_body_stripped.replace(/<\/td>/g, 'zqbd');
          //remove all tags
          question_body_stripped = question_body_stripped.replace(removeTagsPattern, '');
          var isMatch = question_text.toLowerCase().trim().indexOf(searched_term) !== -1 || question_body_stripped.toLowerCase().trim().indexOf(searched_term) !== -1
          if(isMatch){
            var searchQuery;
            var matchedBullets = [];
            var matchedText;
            //first check if the question body has tables or bullets
            if(question_body_stripped.toLowerCase().trim().indexOf('zqbc') !== -1){
              var extractBulletsPattern = "zqbc(.*?)zqbd";
              searchQuery = new RegExp(extractBulletsPattern, 'ig');
              //remove all bullets and tds, will use if match is located in question outside of bullets
              var regText = question_body_stripped.toString().replace(searchQuery, '');
              //make an array of all bullets and tds
              var bullets = question_body_stripped.toString().match(searchQuery);
              //need to make lowercase for search
              var searchBullets = question_body_stripped.toLowerCase().trim().toString().match(searchQuery);

              for(var j = 0; j < bullets.length; j++){
                if(searchBullets[j].indexOf(searched_term) !== -1){
                  // remove zqbc and zqbd 
                  var matchedBullet = bullets[j].replace(/zqbc/g, '');
                  matchedBullet = matchedBullet.replace(/zqbd/g, '');
                  matchedBullets.push(matchedBullet);
                }
              }

              if(matchedBullets.length){
                matchedText = matchedBullets;
              }else{
                searchQuery = new RegExp(extractSentencePattern, 'ig');
                matchedText = regText.match(searchQuery)
              }

            }else{
              searchQuery = new RegExp(extractSentencePattern, 'ig');
              matchedText = question_body_stripped.toString().match(searchQuery)
            }
            
            var matchedObj = {
              id: id,
              question_text: question_text,
              question_body: matchedText
            };

            matches.push(matchedObj)
          }
        }
      }
      commit('updateSearchMatches', matches)
    }
  },
  getters: {
    mobileMentorQuestions: state => state.mobileMentorQuestions,
    pretestQuestions: state => state.pretestQuestions,
    mediaItems: state => state.mediaItems,
    glossaryTerms: state => state.glossaryTerms,
    small: state => state.small,
    canSkip: state => state.canSkip,
    randomize: state => state.randomize,
    showFeedback: state => state.showFeedback,
    showIntro: state => state.showIntro,
    showPretest: state => state.showPretest,
    showResults: state => state.showResults,
    showReport: state => state.showReport,
    showSearch: state => state.showSearch,
    showTOC: state => state.showTOC,
    showMobileMentor: state => state.showMobileMentor,
    showModal: state => state.showModal,
    showBlocker: state => state.showBlocker,
    correct: state => state.correct,
    incorrect: state => state.incorrect,
    percentCorrect: state => state.percentCorrect,
    searchQuery: state => state.searchQuery,
    searchMatches: state => state.searchMatches,
    currentModule: state => state.currentModule,
    currentModuleQuestion: state => state.currentModuleQuestion,
    previousModuleQuestion: state => state.previousModuleQuestion,
    currentPretestQuestion: state => state.currentPretestQuestion,
    currentPretestPage: state => state.currentPretestPage,
    pretestAnswers: state => state.pretestAnswers,
    minimumScore: state => state.minimumScore,
    maximumAttempts: state => state.maximumAttempts,
    completed: state => state.completed,
    completedPretest: state => state.completedPretest,
    moduleAssetFolderName: state => state.moduleAssetFolderName,
    moduleTitle: state => state.moduleTitle,
    trackingType: state => state.trackingType,
    trackingId: state => state.trackingId,
    trackingString: state => state.trackingString,
    requiresAttestation: state => state.requiresAttestation,
    hasMobileMentor: state => state.hasMobileMentor,
    hasPretest: state => state.hasPretest,
    hasBibliography: state => state.hasBibliography,
    hasGlossary: state => state.hasGlossary,
    viewedQuestions: state => state.viewedQuestions,
    questionHistory: state => state.questionHistory,
    disclaimer: state => state.disclaimer,
    sectionsToReview: state => state.sectionsToReview,
  },
  modules: {

  }
})
